import { Component, OnInit, AfterViewInit, DoCheck, NgZone, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, Validator, AbstractControl} from '@angular/forms';
import { PasswordMatch} from '../../service/passwordMatch';
import { HttpService } from '../../service/http.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
declare var $: any;
// import 'select2';
import 'jquery-jcrop';
import { FacebookService, LoginResponse, LoginOptions, UIResponse,
  UIParams, FBVideoComponent } from 'ngx-facebook';
import { UserService } from '../../service/user.service';
import { eventEmitterService } from '../../service/eventEmitter.service';
import { UserPlanService } from "../../service/userplan.service";
import * as AES from 'crypto-js/aes';
import * as Utf8 from 'crypto-js/enc-utf8';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

//Base64 encode of 'mycoopSocialNetwork'
var secretKey = 'bXljb29wU29jaWFsTmV0d29yaw==';

@Component({
  selector: 'app-signup-form',
  templateUrl: './signup-form.component.html',
  styleUrls: ['./signup-form.component.css']
})
export class SignupFormComponent implements OnInit {
  @Input() signupFormName;
 selectedCountries;
  signup: FormGroup;
  tocData;
  error;
  countriesList;
  Jcrop;
  src;
  imageCoords;
  isImage = false;
  file;
  data;
  isTocAccepted;
  isSubmitted;
  previewData;
  buildingAddress;
 // submited;
  name; email; picture;
  countryCode;
 // submited;
  defaultCountryCode = 1;
  passwordPass;
  streetAddress = '';

  facebookInfo;
  isFacebookUser: boolean = false;
  newUserSetup;
  emailRead = false;
  userPlan;
  commonsignup;
  btnChg = 'Continue';
  clientUrl = environment.clientUrl;
  userName;
  showCountryDropdown = false;
  selectedCountry: any;

  constructor( private fb: FormBuilder,
               private _http: HttpService,
               private http: HttpClient,
               private plan : UserPlanService,
               private fbook: FacebookService,
               private emitter: eventEmitterService,
               private ngZone: NgZone,
               private _router: Router,
               private userService: UserService,
               private store: Store<any>) {
              fbook.init({
                appId: '262874930884852',
                xfbml: true,
                version: 'v2.9',
          });

      }

  ngOnInit() {

    //get terms and conditions json from server
    this._http.getTermsAndConditions().subscribe(data => {this.tocData = data; });
    //get all country list json file from server
    this._http.getCountries().subscribe(data => this.countriesList = data);

    this.name = '';
    this.email = '';
    this.picture = '';

    //signup model driven form
    this.signup = this.fb.group({
      firstName   : ['', Validators.compose([Validators.required, Validators.maxLength(15), Validators.pattern('^([a-zA-Z-\'])+([a-zA-Z- ]+)?$')])],
      lastName: ['', [Validators.required, Validators.maxLength(15), Validators.pattern('^([a-zA-Z-\'])+([a-zA-Z- ]+)?$') ]],
      email       : ['', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)], this.emailValidator.bind(this)],
      country     : this.fb.group({
          code       :  ['', Validators.required],
          number     : ['', [Validators.required, Validators.minLength(6), Validators.maxLength(15), Validators.pattern(/^(?=.*[0-9])[- +()0-9]+$/)]],
        }),
      companyName : [''],
      password    : this.fb.group({
          pass        : ['', Validators.compose([Validators.required, Validators.minLength(6)])],
          confirmPass     : ['', [Validators.required]]
        }, {validator: PasswordMatch}),
      buildingUnit : ['', [Validators.pattern('^[1-9a-zA-z][0-9a-zA-z]*$')]],
       //toc               : ['', Validators.compose([Validators.required, Validators.pattern('true')])]
    });

    this.passwordPass = "password";

    //if (this.signupFormName === 'buildingmanager'){this.signup.get('buildingUnit').setValue(1); }

    this.store.select('build').subscribe((data) => {
      //console.log(data);
      if (data[0].address){
        this.buildingAddress = data;
      }

      if(data[0].userNew){
         this.newUserSetup = data[0].userNew;
         this.signup.get('firstName').patchValue(this.newUserSetup.firstName);
         this.signup.get('lastName').patchValue(this.newUserSetup.lastName);
         this.signup.get('email').patchValue(this.newUserSetup.email);
         var code = this.newUserSetup.country.code;
         if($.isNumeric(code)) {
           this.defaultCountryCode = (code != null) ? code : '1';
         }else{
           this.defaultCountryCode = (code != null) ? code.trim() : '1';
         }
         this.signup.get('country.code').patchValue(this.defaultCountryCode.toString());
         var phone = this.newUserSetup.country.number.trim().toString();
         if(phone) {
           this.signup.get('country.number').patchValue(phone);
         }
         this.emailRead = true;
      }

      this.streetAddress = data[0].address.formattedAddress;
      var sample=this.streetAddress;
      if(sample){
        this.streetAddress = sample.replace(/\s*,\s*/g, ",");
      }

    });

    //Refill the signup form with exists information
    var ifUserDataPresent = this.plan.getUserData();
    if(ifUserDataPresent){
        var userDataPresent = ifUserDataPresent.userData;
        this.signup.get('firstName').patchValue(userDataPresent.firstName);
        this.signup.get('lastName').patchValue(userDataPresent.lastName);
        this.signup.get('email').patchValue(userDataPresent.email);
        this.signup.get('buildingUnit').patchValue(userDataPresent.buildingUnit);
        if(userDataPresent.password && userDataPresent.password.pass){
          this.signup.get('password.pass').patchValue(userDataPresent.password.pass);
        }

        if(userDataPresent.password && userDataPresent.password.confirmPass){
          this.signup.get('password.confirmPass').patchValue(userDataPresent.password.confirmPass);
        }
        this.signup.get('buildingUnit').patchValue(userDataPresent.buildingUnit);

       // if(userDataPresent.country && userDataPresent.country.code){
          //var code = userDataPresent.country.code;
          // if($.isNumeric(code)) {
             this.defaultCountryCode = 1;
          // }else{
          //   this.defaultCountryCode = (code != null) ? code.trim() : '1';
          // }
          this.signup.get('country.code').patchValue(this.defaultCountryCode.toString());
       // }

       if(userDataPresent.country && userDataPresent.country.number){
        var phone = userDataPresent.country.number.trim().toString();
        if(phone) {
          this.signup.get('country.number').patchValue(phone);
        }
       }
       if(ifUserDataPresent.image && ifUserDataPresent.image.profileImage){
        this.src = ifUserDataPresent.image.profileImage;
       }
        this.btnChg = 'Continue';
    }

    var plan = this.plan.getUserPlan();
    if(plan != null){
      this.btnChg = 'Create Account';
    }
  }

  toggleCountryDropdown() {
    this.showCountryDropdown = !this.showCountryDropdown;
  }

  selectCountry(country) {
    this.countryCode = country.callingCodes[0];
    this.selectedCountry = country;
    this.signup.get('country.code').patchValue(country.callingCodes[0]);
    this.showCountryDropdown = false;
  }

  emailValidator(control: AbstractControl): Promise<any> | Observable<any> {
    return new Promise(resolve => {
      const email = control.value;

      // Regular expression for email validation
      const emailRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (emailRegExp.test(email)) {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        this.http.post<{ exists: boolean }>(environment.apiUrl + 'auth/isEmailExists', { email }, { headers })
          .pipe(
            map(data => {
              if (this.newUserSetup) {
                resolve(null);
              } else {
                resolve({ duplicate: true });
              }
            }),
            catchError(() => {
              resolve(null);
              return of(null);
            })
          ).subscribe();
      } else {
        resolve({ duplicate: true });
      }
    });
  }
  ngAfterViewInit()
  {
    $('.countryflag').select2({
        templateResult : this.countryCodeFormat,
        templateSelection : this.countryCodeFormat,
        minimumResultsForSearch: -1
    });

    $('.select2-container').css({
      'width': '100px'
    });


    $('.countryflag').on('change', (e) => {
      this.signup.get('country.code').setValue($(e.target).val().toString().slice(3));
            //console.log($(e.target).val().toString().slice(3));
    });
    this.signup.get('country.code').setValue(this.defaultCountryCode.toString());
    // $('#countrycode-container').find('img').css('position', 'relative');
    // $('#countrycode-container').find('img').css('top', '-5px');
    // this.signup.get('country.code').setValue(this.defaultCountryCode.toString());

  }
  isImageUpdate(e){
    if (e) this.isImage = true;

  }

  // isTocAcceptedMethod(value){
  //   if(value=='true'){
  //      this.signup.get('toc').setValue(true);
  //     this.isTocAccepted = true;
  //     if(this.isSubmitted)this.formSubmit(this.signup.value, this.signup.valid);
  //   }else if(value == 'false'){
  //       this.signup.get('toc').setValue(false);
  //       this.isTocAccepted = false;
  //   }
  // }

  formSubmit(value, valid)
  {
      if (!this.selectedCountry) {
        this.countryCode = this.defaultCountryCode;
        this.signup.get('country.code').patchValue(this.defaultCountryCode.toString());
      }
      //Check for activation link , if not then normal taken singup flow process
      if(!this.newUserSetup) {

        // console.log(this.selectedCountries);
        this.error = undefined;
        if (this.signupFormName === 'buildingmanager') {
          // this.signup.get('buildingUnit').setValue(12);
          //delete value.buildingUnit;
        }
        else {

          delete value.companyName;
        }
        //console.log('condition 1');
        if (valid) this.isSubmitted = true;
        if (valid) {
            //console.log('condition 2');
            value.imageCoords = this.imageCoords;
            this.store.select('build').subscribe((data) => { this.data = data; });
            this.data[0].userData = value;
            this.data[0].userData.unitNumber = value.buildingUnit;
            this.data[0].userData.facebookInfo = this.facebookInfo;
            this.data[0].userData.isFacebookUser = this.isFacebookUser
            this.data[0].image.profileImage = sessionStorage.getItem('userImage');
            //console.log(' Profile Image', sessionStorage.getItem('userImage'));
            this.data[0].image.buildingImage = sessionStorage.getItem('buildingImage');
            this.data[0].image.facebookImage = localStorage.getItem('facebookImage');
            //console.log(this.data);

            this.userPlan = this.plan.getUserPlan();
            console.log('userPlan', this.userPlan);

            //Sign up flow following from pricing page
            if (this.userPlan){

               if (this.userPlan == "resident" && this.signupFormName === 'resident') {

                  this._http.residentSignup(this.data[0]).subscribe(res => {
                    //console.log(res);
                     if (res.success) {
                        sessionStorage.removeItem('buildingImage');
                        localStorage.removeItem('buildingImage');
                        sessionStorage.removeItem('userImage');
                        localStorage.removeItem('userImage');
                        localStorage.removeItem('facebookImage');
                        this.signup.reset();
                        this._router.navigate(['thankyou'], {
                            queryParams: {
                              signup: true,
                              name: res.message.name,
                              email: res.message.email
                            }
                          }
                        );
                     }

                       /**
                       * facebook user automatic login
                       */
                       if(res.user && res.user.facebookInfo){
                        window.location.href= environment.apiUrl+'auth/facebook';
                       }
                   },
                  (error) => {
                    this.error = [error.message];
                    console.log(this.error, error);
                   });

               } else {
                    this.plan.setUserData(this.data[0]);
                    //const header = new Headers();
                    //header.append('Content-Type', 'application/json');
                    this.http.post(environment.apiUrl + 'buildingManager/saveBuildingManagerSession', {data: value}, {
                    }).subscribe(data => {
                      this._router.navigate(['managerprofile/managerbuilding'], {
                        queryParams: {
                          processing: true
                        }
                      });
                    }, (error) => {
                    });
               }

            } else if (!this.userPlan && !this.newUserSetup) {
                //console.log("Residents User Data ===========", this.data[0]);
                //console.log("Manager User Data ===========", value);
                //Sign up flow following from home page
                this.plan.setUserData(this.data[0]);
                console.log('Building Data', this.data);
                var planEncrypt = AES.encrypt('chooseplan' , secretKey);
                setTimeout(() => {
                  this._router.navigate(['pricing'], { queryParams: { select : planEncrypt, newbuilding: this.data[0].newBuilding } });
                }, 1);
            }
        }

      }else if(this.newUserSetup){

          if(valid) {
            //Check for activation link , if yes then activate their account with auto login process
            var profileImg = sessionStorage.getItem('userImage');
            value.unitNumber = value.buildingUnit;

            value.customRole = this.newUserSetup.customRole;
            value.role = this.newUserSetup.role;

            delete value.buildingUnit;
            var userAccountSetup = {
              userData: value,
              image: {profileImage: profileImg}
            }
            this._http.residentAccountSetup(userAccountSetup).subscribe(res => {
                this.newUserSetup = userAccountSetup;
                if (res.success) {
                  sessionStorage.removeItem('buildingImage');
                  localStorage.removeItem('buildingImage');
                  sessionStorage.removeItem('userImage');
                  localStorage.removeItem('userImage');
                  localStorage.removeItem('facebookImage');
                  this.signup.reset();
                  /*this._router.navigate(['thankyou'], {
                      queryParams: {
                        signup: true,
                        name: res.message.name,
                        email: res.message.email
                      }
                    }
                  );*/
                }

                if (res.token) {
                  var buildingIds = [];
                  for (let building of res.user.building) {
                    buildingIds.push(building.id);
                  }
                  this.userName = res.user.firstName;
                  localStorage.setItem('token', res.token)
                  var isManager = (res.user.type === 'manager');
                  if (!isManager) {
                    localStorage.setItem('userBuildingId', res.user.building[0].id);
                  } else {
                    localStorage.setItem('userBuildingId', buildingIds.toString());
                  }

                  localStorage.setItem('residents', res.user.id);
                  localStorage.setItem('type', res.user.type);
                  localStorage.setItem('maintenance', res.user.isMaintenanceManager);
                  localStorage.setItem('isManager', isManager.toString());
                  $('#thankyou_modal').show();
                  //this._router.navigate(['feed']);
                }
              },
              (error) => {
                this.error = [error.message];
                console.log(this.error, error);
              });
          }
      }
  }
  preview(){
    this.store.select('build').subscribe((data) => {
      data[0].form = this.signup.value;
      this.previewData = data;
      console.log(this.previewData, 'test');
    });
  }

  /*
  * Modal popup close when click 'close' icon on modal popup
  */
  modalClose(){
    $('#thankyou_modal').remove();
    this._router.navigate(['/feed']);
  }

  acceptToc(){
    if (this.signup.valid && !this.isTocAccepted){
      $('#toc').modal('show');

    }
    // else{
    //   this.formSubmit(this.signup.value, this.signup.valid);
    // }
  }

  // update country code select option with image
  countryCodeFormat(option)
  {
    if (!option.id) {
      return option.text;
    }
    const imageUrl = environment.apiUrl + ($(option.element).attr('data-image') || option.url);
    if (imageUrl) {
      const $option = $(
        '<span class="flag-and-text"><img src="' + imageUrl + '" class="flag-icon" /> ' + option.text + '</span>'
      );
      return $option;
    }
    return option.text;
  }
getFacebookProfile(){

  const loginOptions: LoginOptions = {
      enable_profile_selector: true,
      return_scopes: true,
      scope: 'public_profile,email'
    };

    this.fbook.login(loginOptions)
      .then((res: LoginResponse) => {
        this.ngZone.run(() => {
          this.getProfile();
        });

        console.log('Logged in', res);
      })
      .catch(this.handleError);


}
    getProfile() {
    this.fbook.api('/me?fields=email,id,first_name,last_name,picture.type(large)')
      .then((res: any) => {
        console.log('Got the users profile', res.id);

        this.userService.getUserByFacebookId(res.id).subscribe((res)=>{

          console.log('facebook user found', res)
          window.location.href = environment.apiUrl+'auth/facebook'

        },(error)=>{
          console.log('no facebook user')
          this.isFacebookUser = true;
          this.email = res.email;
          this.name = res.name;
          this.facebookInfo = res.id;
          this.picture = res.picture.data['url'];
          console.log('FB Image URL : ', res.picture.data['url']);
          this.signup.get('firstName').patchValue(res.first_name);
          this.signup.get('lastName').patchValue(res.last_name);
          this.signup.get('email').patchValue(res.email);
          this.signup.get('password.pass').disable();
          this.signup.get('password.confirmPass').disable();
       //  this.fbImageProcess(res.picture.data['url']);
          this.src = res.picture.data['url'];
          localStorage.setItem('facebookImage', this.src);
        })

      })
      .catch(this.handleError);
  }
  private handleError(error) {
    console.error('Error processing action', error);
  }
  EditProfile(){
    this._router.navigate(['building/addbuilding']);
  }

  ngDoCheck(){
    // This function is no longer needed as select2's templateResult should handle rendering.
    // Keeping it commented out for now, but it can be removed entirely.
  }
}
